export default function determineLocationOfNewLabel({ map, labels }) {
  const mapCenter = map.getBounds().getCenter()
  const label = labels.find(l => {
    return l.overlay.rectangle && l.overlay.rectangle.getBounds().contains(mapCenter)
  })

  if (!label) return mapCenter.toJSON()

  const bounds = label.overlay.rectangle.getBounds()
  const ne = bounds.getNorthEast()
  const sw = bounds.getSouthWest()
  const width = google.maps.geometry.spherical.computeDistanceBetween(ne, new google.maps.LatLng(ne.lat(), sw.lng()))

  const location = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(label.location), width * 1.1, 90)
  map.setCenter(location)
  return location.toJSON()
}



// WEBPACK FOOTER //
// ./src/helpers/map/determineLocationOfNewLabel.js